<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.globalEdit}}</h3>
</div>
<div class="modal-body">
	<div *ngIf="fieldList && fieldList.length > 0" class="global-edit-main">
	    <div class="well-sm">
	        <div class="row">
		        <div class="text-center">
					<div class="btn-group" role="group" aria-label="edit mode">
					  <button 
					  	type="button" 
					  	class="btn btn-default" 
					  	[ngClass]="{'active': mode === 'update'}" 
					  	(click)="mode = 'update'">
					  		{{LOCALIZATION.edit}}
					  	</button>
					  <button 
					  	type="button" 
					  	class="btn btn-default" 
					  	[ngClass]="{'active': mode === 'replace'}" 
					  	(click)="mode = 'replace'">
					  		{{LOCALIZATION.searchReplace}}
					  </button>
					</div>
				</div>
	        </div>
	    </div>
	    
	    <!-- // Update -->
	   	<div *ngIf="mode === 'update'">
	   		<div class="row">
		   		<div class="well-sm text-center">
			        <div>
	                    <label class="radio-inline">
	                    	<input type="radio" [(ngModel)]="replaceMode" name="replace_mode" (click)="replaceMode = 'replace'" value="replace" />
	                    	{{LOCALIZATION.replaceFields}}
	                    </label>
	                    <label class="radio-inline">
	                    	<input type="radio" [(ngModel)]="replaceMode" name="replace_mode" (click)="replaceMode = 'append'" value="append" />
	                    	{{LOCALIZATION.appendFields}}
	                    </label>
			        </div>
			    </div>
		    </div>
	   		<div class="row">
		   		<div class="col-xs-10 col-xs-offset-1 well-sm text-center" style="background:#eee;">
			        <div class="col-xs-2 col-xs-offset-1"><span id="recordSelect"> {{LOCALIZATION.copyValuesFrom}} </span></div>
			        <div class="col-xs-6">
			            <select 
			            	class="form-control" 
			            	(change)="loadSelectedRecordMetadata()"
			                [(ngModel)]="selectedRecordId" 
			                name="recordSelect" 
			                aria-labelledby="recordSelect">
						    <option *ngFor="let record of batchRecords" [value]="record.id">
						        {{ record.title }}
						    </option>			                
			            </select>
			        </div>
			        <div class="col-xs-1">
	                	<button class="btn btn-primary" (click)="copyValues()">{{LOCALIZATION.apply}}</button>
			        </div>
			    </div>
		    </div>	    
	    </div>    
	    <form #kvForm="ngForm" name="kvForm">
	    	<!-- // Update -->
	    	<div *ngIf="mode === 'update'" class="well-sm global_editdata">
		         <div class="col-xs-12" style="padding-bottom: 16px;" *ngFor="let field of batchEditFields; let field_idx = index; trackBy: trackByIndex;">
		         	<div class="col-xs-3">
		             <select 
		            	class="form-control" 
		            	style="display:inline-block;"
		                [(ngModel)]="field.name"
		                [name]="'fieldSelect_' + field_idx"
		             	(change)="updateBatchEditField( field_idx )" 
		                aria-label="select field"
		                title="Select a field">
						    <option *ngFor="let f of fieldList" [value]="f.name">
						        {{ f.displayName }}
						    </option>
		             </select>
		            </div> 
			       <div class="col-xs-9">
			            <div *ngFor="let value of field.content; let value_idx = index;" style="margin-bottom:8px;">
			            <div [ngSwitch]="field.type">
			            
			                <div *ngSwitchCase="'STRING'">
			                    <textarea class="form-control auto-expand" 
			                    	autoExpand 
			                        [(ngModel)]="field.content[value_idx]" 
			                        [ngModelOptions]="{ updateOn: 'blur' }"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}"
									minlength="{{field.min}}" 
									maxlength="{{field.max}}"
									[required]="field.required"
			                        placeholder="{{field.placeholder}}" 
			                        title="{{field.placeholder}}"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx"
			                    	rows="1" 
			                    	style="width:80%;">
			                    </textarea>	                            
			                </div>
			                
			                <div *ngSwitchCase="'BOOLEAN'">
			                    <label style="display:inline;" class="control control--checkbox">
			                        <input type="checkbox" 
			                        	class="item-input"
			                        	style="width:80%;"
			                            [(ngModel)]="field.content[value_idx]"
			                        	[attr.id]="field.name + field_idx + value_idx"
			                        	name="{{field.name}}_{{field_idx}}_{{value_idx}}"
										[required]="field.required"
			                        	placeholder="{{field.placeholder}}" 
			                        	title="{{field.placeholder}}"
			                            [attr.aria-label]="field.name + field_idx + ' value ' + value_idx"  />
			                        <div class="control__indicator"></div>
			                    </label>
			                </div>
			                
			                <div *ngSwitchCase="'EMAIL'">
			                    <input type="email" 
			                    	class="item-input ng-animate-disabled" 
			                    	style="width:80%;"
			                        [(ngModel)]="field.content[value_idx]"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}"
			                        minlength="{{field.min}}" 
			                        maxlength="{{field.max}}"
									[required]="field.required"
			                        placeholder="{{field.placeholder}}" 
			                        title="{{field.placeholder}}"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx" />
			                </div>
			                
	               			<div *ngSwitchCase="'NUMBER'">
			                    <input type="number" 
			                    	class="item-input ng-animate-disabled" 
			                    	style="width:80%;"
			                        [(ngModel)]="field.content[value_idx]"
			                        #fieldControl="ngModel"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}"
			                        min="{{field.min}}"
			                        max="{{field.max}}"
									[required]="field.required"
			                        placeholder="{{field.placeholder}}" 
			                        title="{{field.placeholder}}"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx" />
			                    <span class="help-block required" *ngIf="fieldControl?.invalid && fieldControl?.touched">
			                        {{ LOCALIZATION.numberInvalidMinMax | formatString: 
			                        	(field.min ? field.min : "(any value)") :
			                        	(field.max ? field.max : "(any value)")
			                        }}
			                    </span>	                                 
			                </div>
			                
			                <div *ngSwitchCase="'WKT'">
			                    <input type="text" 
			                    	class="item-input ng-animate-disabled" 
			                    	style="width:80%;"
			                        [(ngModel)]="field.content[value_idx]"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}"
			                        minlength="{{field.min}}" 
			                        maxlength="{{field.max}}"
									[required]="field.required"
			                        placeholder="{{field.placeholder}}" 
			                        title="{{field.placeholder}}"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx" />
			                </div>			                
							
			                <div *ngSwitchCase="'DATE'">
			                    <input type="text" 
			                           class="item-input flatpickr" 
			                           style="width:68%;"  
				                       [(ngModel)]="field.content[value_idx]"
				                       #fieldControl="ngModel"
				                       [attr.id]="'daterange_' + field.name + field_idx + value_idx"
				                       name="{{'daterange_' + field.name}}_{{field_idx}}_{{value_idx}}"			                           
			                           placeholder='{{field.placeholder}}' 
			                           title="{{field.placeholder}}"
			                           [required]="field.required"                                 
			                           (focus)="openDatePicker(field.name, field_idx, value_idx)" 
			                           [attr.aria-label]="field.name + field_idx + ' value ' + value_idx"
			                           
					                   dateValidate
					                   [dateValidateValue]="field.content[value_idx]"
					                   
					                   dateRangeValidate
					                   [dateRangeValidateValue]="field.content[value_idx]"
					                   [dateRangeValidateMin]="datePickerOptions['minDate']"
					                   [dateRangeValidateMax]="datePickerOptions['maxDate']"/>                           
			                    <span>
			                        <button type="button" 
			                        	class="btn btn-default"
			                        	(click)="openDatePicker(field.name, field_idx, value_idx)" 
			                        	[hidden]="field.readOnly" 
			                        	title="{{LOCALIZATION.openCalendar}}"
			                        	[attr.aria-label]="LOCALIZATION.openCalendar">
			                            	<i class="fas fa-calendar-alt" aria-hidden="true"></i>
			                        </button>
			                    </span>                            
			                    <span *ngIf="fieldControl?.errors?.['datevalidate']" class="required">{{field.content[value_idx]}} - {{ LOCALIZATION.dateInvalid | formatString: dateFormat }}</span>
			                    <span *ngIf="fieldControl?.errors?.['datevalidateminmax']" class="required">
			                        {{ LOCALIZATION.dateInvalidMinMax | formatString:
			                            (datePickerOptions['minDate'] && datePickerOptions['minDate'].isValid() ? datePickerOptions['minDate'].format(dateFormat) : "anytime") :
			                            (datePickerOptions['maxDate'] && datePickerOptions['maxDate'].isValid() ? datePickerOptions['maxDate'].format(dateFormat) : "anytime")
			                        }}
			                    </span>
			                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>
			                </div>			                
			                
			                <div *ngSwitchCase="'LIST'">
			                    <select class="form-control" 
			                    	style="display:inline-block;width:80%;"
			                    	(change)="updateBatchEditFieldValue(field_idx, value_idx)" 
			                        [(ngModel)]="field.content[value_idx]"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}" 
			                        title="{{field.placeholder}}"
			                        [required]="field.required"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx">
								    <option *ngFor="let option of field.allowedValues" [value]="option.value">
								        {{ option.name }}
								    </option>			                        
			                    </select>
			                </div>			                 
			                
			                <div *ngSwitchCase="'READONLY'">
			                    <input readonly 
			                    	class="item-input" 
			                    	disabled="disabled" 
			                    	style="width:80%;"
			                        [(ngModel)]="field.content[value_idx]"
			                        [attr.id]="field.name + field_idx + value_idx"
			                        name="{{field.name}}_{{field_idx}}_{{value_idx}}"
			                        title="{{field.placeholder}}"
			                        [attr.aria-label]="field.name + field_idx + ' value ' + value_idx" />
			                    <div class="help-block" style="width:80%;">{{field.message}}</div>       
			                </div>
			                
					        <div style="display:inline-block; margin-top:6px;">
					        	<button (click)="removeBatchEditField(field_idx, value_idx)" 
					        		title="Remove this field"
					        		aria-label="Remove this field"  
					        		class="btn btn-sm btn-circle" 
					        		style="margin-right:3px">
						       			<i class="fa fa-trash text-red" aria-hidden="true"></i>
						        </button>
						        <button *ngIf="!field.readOnly && field.ismultiple" 
						        	(click)="dupeBatchEditField(field_idx)" 
						        	title="Add a new value" 
						        	aria-label="Add a new value"
						        	class="btn btn-sm btn-circle">
						        		<i class="fa fa-plus accent-color" aria-hidden="true"></i>
						        </button>
						        <button *ngIf="field.type === 'WKT' && field.readOnly != 'true'" 
						        	(click)="onGeotag(field_idx, value_idx)" 
						        	title="Geotag"
						        	aria-label="Geotag" 
						        	class="btn btn-sm btn-circle" 
						        	style="margin-left:3px">
				                		<i class="fa fa-globe accent-color" aria-hidden="true"></i>
				                </button>	
			                </div>			                	
			                
			                <span *ngIf="kvForm.form.controls[field.name + field_idx + value_idx]?.errors?.['required']" class="required">{{LOCALIZATION.required}}. </span>
			                <span *ngIf="getParentFieldRequiredMessage(field_idx)" class="required">{{LOCALIZATION.selectParentField}} {{getParentFieldRequiredMessage(field_idx)}}</span> 
			                
			                </div>	<!-- // switch -->
			            </div>
			        </div>
		         </div>
		         <div>
		         	<button class="btn btn-primary" (click)="addBatchEditField()">Add a Field</button>
		         </div>         
	     	</div> 
	        
	     	<!-- // Replace --> 
	     	<div *ngIf="mode === 'replace'" class="well-sm global_editdata">
		         <div class="col-xs-12" style="padding-bottom: 16px;" *ngFor="let field of batchSearchReplaceFields; let field_idx = index; let first = first; trackBy: trackByIndex;">
		         	<div class="col-xs-3 col-xs-offset-1">
		             <select 
		            	class="form-control" 
		            	style="display:inline-block;"
		                [(ngModel)]="field.name"
		                [name]="'fieldSelect_' + field_idx"
		             	(change)="updateBatchSearchReplaceField( field_idx )" 
		                aria-label="select field"
		                title="Select a field">
						    <option *ngFor="let f of fieldList" [value]="f.name">
						        {{ f.displayName }}
						    </option>
		             </select>		             
		            </div> 
			       <div class="col-xs-8" *ngIf="field.type !== 'READONLY' && field.type !== 'DISABLED'">
			            <div>
			                <div style="margin-bottom:8px;">
		                    	<textarea class="form-control auto-expand" 
			                    	autoExpand 
			                        [(ngModel)]="field.search" 
			                        [ngModelOptions]="{ updateOn: 'blur' }"
			                        [attr.id]="'s_' + field.name + field_idx"
			                        name="s_{{field.name}}_{{field_idx}}"
			                        placeholder="Field Search" 
			                        title="Field Search"
			                        [attr.aria-label]="'Search field ' + field.name + field_idx + ' value '"
			                    	rows="1" 
			                    	style="width:85%;">
			                    </textarea>				                                               
			                </div>
			                <div>
		                    	<textarea class="form-control auto-expand" 
			                    	autoExpand 
			                        [(ngModel)]="field.replacement" 
			                        [ngModelOptions]="{ updateOn: 'blur' }"
			                        [attr.id]="'r_' + field.name + field_idx"
			                        name="r_{{field.name}}_{{field_idx}}"
			                        placeholder="Field Replacement" 
			                        title="Field Replacement"
			                        [attr.aria-label]="'Replacement field ' + field.name + field_idx + ' value '"
			                    	rows="1" 
			                    	style="width:85%;">
			                    </textarea>			                    		                            
			                </div>		                
			            </div>
			        </div>
			       <div class="col-xs-8" *ngIf="field.type === 'READONLY' || field.type === 'DISABLED'">
			            <div>
			                <div>
			                    <input type="text" 
			                    	readonly 
			                    	class="item-input disabled" 
			                    	disabled="disabled" 
			                    	style="width:85%;"
			                    	[attr.aria-label]="'Search field ' + field.name + field_idx + ' value '" />
			                </div>
			                <div>
			                    <input type="text" 
			                    	readonly 
			                    	class="item-input disabled" 
			                    	disabled="disabled" 
			                    	style="width:85%;"
			                        [attr.aria-label]="'Replacement field ' + field.name + field_idx + ' value '"/>
			                </div>
			                <div class="help-block" style="width:85%;">{{field.message}}</div> 		                
			            </div>
			        </div>		        
			        <div>
			        	<button *ngIf="!first" (click)="removeBatchSearchReplaceField(field_idx)" class="btn btn-sm btn-circle" aria-label="Remove">
				        	<i class="fa fa-trash text-red" aria-hidden="true"></i>
				        </button>
	                </div>   	        
		         </div>
		         <div>
		         	<button class="btn btn-primary" (click)="addBatchSearchReplaceField()">Add a Field</button>
		         </div>         
	     	</div> 
	     </form> 
	     
	  	 <div class="global_editdata metadata-container row">
			<div class="col-md-12 col-sm-12 col-xs-12">
			<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
			  <div class="panel panel-default">
			    <div class="panel-heading" role="tab" id="headingOne">
			      <h4 class="panel-title">
					<button class="btn btn-primary collapsed" type="button" data-toggle="collapse" data-target="#collapseOne" data-parent="#accordion" aria-expanded="false" aria-controls="collapseOne">
			          {{LOCALIZATION.viewMetadata}}
	                  <span class="glyphicon glyphicon-chevron-up up"></span>		          
	                  <span class="glyphicon glyphicon-chevron-down down"></span>				  
					</button>		        
			      </h4>
			    </div>
			    <div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
			      <div class="panel-body">
			      	<div *ngFor='let record of batchRecords'>
			        <table class="table table-striped table-bordered table-condensed">
						<tr *ngFor='let data of record.metadataDisplay'>
							<th>{{data.label}}</th>
							<td>{{data.value}}</td>
						</tr>
			        </table>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>	
			</div>	
		 </div>  
		  
	     <div class="modal-footer">
	        <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	        <button class="btn btn-default btn-primary" 
	        	type="button" 
	        	(click)="save()"
	        	[disabled]="(!kvForm.valid && mode == 'update') || inprogress">
	              	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
	             	 {{LOCALIZATION.save}}
	        </button>
	     </div> 
     </div> 
             
     <div *ngIf="fieldList?.length === 0">
     	<div class="text-center">
         <em>{{LOCALIZATION.emptyForm}}</em>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
        </div>         
     </div>     
</div>      
